<ng-template #defaultItemTemplate let-item="item">
    {{item[labelKey]}}
</ng-template>
<ul #list [hidden]="hidden" class="dropdown-menu scrollable-menu" [class.mention-menu]="!styleOff"
    [class.mention-dropdown]="!styleOff && dropUp">
    @for (item of items; track i; let i = $index) {
    <li [class.active]="activeIndex === i" [class.mention-active]="!styleOff && activeIndex === i">
        @if (item.id > 0) {
        <a class="dropdown-item" [class.mention-item]="!styleOff"
            (mousedown)="activeIndex = i;itemClick.emit();$event.preventDefault()">
            <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'item':item}"></ng-template>
        </a>
        }
        @if (item.id === 0) {
        <span>{{item.label}}</span>
        }
    </li>
    }
</ul>